<template lang="html">
  <section class="card-preloader">
    <template v-if="initialCardsPreloaded">
      <PlayingCard
        v-for="card in cards"
        :key="card.id"
        :suit="card.suit"
        :rank="card.rank"
      />
    </template>
    <template v-else>
      <PlayingCard
        v-for="card in initialCards"
        :key="card.id"
        :suit="card.suit"
        :rank="card.rank"
        @image-loaded="handleInitialCardImageLoaded"
      />
    </template>
  </section>
</template>

<script>
import PlayingCard from '@/components/PlayingCard';

export default {
  name: 'CardPreloader',

  components: {
    PlayingCard,
  },

  props: {
    dealerHand: {
      type: Object,
      required: true,
    },

    playerHand: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      initialCardImagesLoaded: 0,
      initialCardsPreloaded: false,
      suits: ['h', 'd', 'c', 's'],
      ranks: ['a', '2', '3', '4', '5', '6', '7', '8', '9', 't', 'j', 'q', 'k'],
    };
  },

  computed: {
    cards() {
      return this.suits
        .map((suit) => this.ranks.map((rank) => ({ suit, rank })))
        .flat();
    },

    initialCards() {
      return this.dealerHand.cards.concat(this.playerHand.cards);
    },
  },

  methods: {
    handleInitialCardImageLoaded(card) {
      this.initialCardImagesLoaded += 1;

      // TODO: Handle case where an image load fails. Use timeout?
      if (this.initialCardImagesLoaded === this.initialCards.length) {
        this.initialCardsPreloaded = true;
        this.$emit('initial-cards-preloaded');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/unstyled-list';

.card-preloader {
  @include unstyled-list;

  position: absolute;
  top: -100vh;
  max-width: 100%;
}
</style>
